import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  ProductOutlined,
  UserOutlined,
  TeamOutlined,
  StockOutlined,
  RiseOutlined,
  UserSwitchOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { ADMIN, SALESMAN } from "../redux/constants/roles";
import { Link } from "wouter";
import { Typography } from "antd";

const { Text } = Typography;
export const SIDEBAR_ROUTES = {
  [SALESMAN]: [
    {
      key: "heading-orders-1",
      label: <Text className="text-base font-semibold">Order Management</Text>,
      type: "group",
    },
    {
      key: "1",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-drafts">Draft Orders</Link>,
    },
    {
      key: "2",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/dealer-orders">Dealer Order Requests</Link>,
    },
    {
      key: "3",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-requests">Seller Order Requests</Link>,
    },
    {
      key: "4",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/pending-sub-orders">Dealer Sub Orders</Link>,
    },
    {
      key: "5",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/orders">Orders</Link>,
    },
    {
      key: "6",
      icon: <CloseCircleOutlined />,
      label: <Link to="/admin/failed-orders">Failed Orders</Link>,
    },
    {
      key: "heading-orders-2",
      label: (
        <Text className="text-base font-semibold ">Products Management</Text>
      ),
      type: "group",
    },
    {
      key: "7",
      icon: <ProductOutlined />,
      label: <Link to="/admin/products-list">Products</Link>,
    },
    {
      key: "8",
      icon: <DollarCircleOutlined />,
      label: <Link to="/admin/products-pricing">Products Price</Link>,
    },
  ],
  [ADMIN]: [
    {
      key: "heading-orders-1",
      label: <Text className="text-base font-semibold ">Analytics</Text>,
      type: "group",
    },
    {
      key: "2",
      icon: <StockOutlined />,
      label: <Link to="/admin/analysis/stock-analysis">Stocks Analysis</Link>,
    },
    {
      key: "3",
      icon: <RiseOutlined />,
      label: (
        <Link to="/admin/analysis/product-performance">
          Product Performance
        </Link>
      ),
    },
    {
      key: "4",
      icon: <UserSwitchOutlined />,
      label: (
        <Link to="/admin/analysis/top-dealers">Top Performing Dealer(s)</Link>
      ),
    },
    {
      key: "5",
      icon: <BarChartOutlined />,
      label: (
        <Link to="/admin/analysis/product-forecast">Product Forecasting</Link>
      ),
    },
    // {
    //   key: "6",
    //   icon: <DashboardOutlined />,
    //   label: <Link to="/admin/dashboard">Dashboard</Link>,
    // },
    {
      key: "heading-orders-2",
      label: <Text className="text-base font-semibold">Order Management</Text>,
      type: "group",
    },
    // {
    //   key: "2",
    //   icon: <ClockCircleOutlined />,
    //   label: <Link to="/admin/order-drafts">Draft Orders</Link>,
    // },
    {
      key: "7",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/dealer-orders">Dealer Order Requests</Link>,
    },
    {
      key: "8",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-requests">Seller Order Requests</Link>,
    },
    {
      key: "9",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/pending-sub-orders">Dealer Sub Orders</Link>,
    },
    {
      key: "10",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/orders">Orders</Link>,
    },
    {
      key: "11",
      icon: <CloseCircleOutlined />,
      label: <Link to="/admin/failed-orders">Failed Orders</Link>,
    },
    {
      key: "heading-orders-3",
      label: (
        <Text className="text-base font-semibold ">Products Management</Text>
      ),
      type: "group",
    },
    {
      key: "12",
      icon: <ProductOutlined />,
      label: <Link to="/admin/products-list">Products</Link>,
    },
    {
      key: "13",
      icon: <DollarCircleOutlined />,
      label: <Link to="/admin/products-pricing">Products Price</Link>,
    },
    {
      key: "heading-orders-4",
      label: <Text className="text-base font-semibold ">Users Management</Text>,
      type: "group",
    },
    {
      key: "14",
      icon: <UserOutlined />,
      label: <Link to="/admin/products-list">Dealers</Link>,
    },
    {
      key: "15",
      icon: <TeamOutlined />,
      label: <Link to="/admin/products-pricing">Salesmen</Link>,
    },
  ],
};
